const inspectionAndEvaMge = r => require.ensure([], () => r(require('@/page/inspectionAndEvaMge/inspectionAndEvaMge')), 'inspectionAndEvaMge');
const evaluationMge = r => require.ensure([], () => r(require('@/page/inspectionAndEvaMge/evaluationMge/evaluationMge')), 'evaluationMge');
const evaArea = r => require.ensure([], () => r(require('@/page/inspectionAndEvaMge/evaArea/evaArea')), 'evaArea');
const inspectiontemplateMge = r => require.ensure([], () => r(require('@/page/inspectionAndEvaMge/templateMge/templateMge')), 'templateMge');
const evaluationArea = r => require.ensure([], () => r(require('@/page/inspectionAndEvaMge/evaluationArea/evaluationArea')), 'evaluationArea');
const addCheckAndReview = r => require.ensure([], () => r(require('@/page/inspectionAndEvaMge/addCheckAndReview/addCheckAndReview')), 'addCheckAndReview');

const inspectionEvaluationDetail = r => require.ensure([], () => r(require('@/components/indexnew/inspectionEvaluationDetail')), 'inspectionEvaluationDetail');


const inspectionAndEvaMgeRouter = {
  path: '',
  component: inspectionAndEvaMge,
  meta: { icon: 'inspectionAndEvaMge', right: [],
    isShowMenu: true,
    keepAlive:true,
  },
  name: '检查考评',
  children: [
    { path: '/evaluationMge', component: evaluationMge, name: '检查考评管理',
      meta: { right: ['检查考评管理'],
        isShowMenu: true,
        keepAlive:true,
      }, },
    { path: '/inspectiontemplateMge', component: inspectiontemplateMge, name: '检查考评模板管理',
      meta: { right: ['检查考评模板管理'],
        isShowMenu: true,
        keepAlive:true,
      }, },
    { path: '/evaArea', component: evaArea, name: '考评区域',
      meta: { right: ['检查考评管理'],
        isShowMenu: false,
        keepAlive:true,
      }, },
    { path: '/evaluationArea', component: evaluationArea, name: '考评区域',
      meta: { right: ['检查考评模板管理'],
        isShowMenu: false,
        keepAlive:true,}, },
    { path: '/addCheckAndReview', component: addCheckAndReview, name: '发起检查考评',
      meta: { right: ['检查考评管理'],
        isShowMenu: true,
        keepAlive:true,
      }, },
    { path: '/inspectionEvaluationDetail', component: inspectionEvaluationDetail, name: '检查考评细节详情',
      meta: { right: ['检查考评细节详情'],
        isShowMenu: true,
        keepAlive:true,
      }, }
  ]
};

export default inspectionAndEvaMgeRouter;